module.exports = __webpack_public_path__ + "static/img/impression.f626f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/rorando/impression.png
// module id = TlT5
// module chunks = 0